function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconWorldRexFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.123 23h-6.246c.882 3.193 2.235 5 3.123 5 .888 0 2.241-1.807 3.123-5zM12.877 9h6.246C18.241 5.807 16.888 4 16 4c-.888 0-2.241 1.807-3.123 5zM12.424 21h7.152c.215-1.199.355-2.542.402-4h-7.957c.047 1.458.188 2.801.402 4zM12.424 11a27.885 27.885 0 00-.402 4h7.957a27.878 27.878 0 00-.403-4h-7.152z",
    fill: props.color
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.19 23c-.443 1.787-1.052 3.322-1.775 4.498A11.962 11.962 0 0116 28c-1.188 0-2.332-.18-3.415-.502-.724-1.176-1.333-2.711-1.776-4.498H6.273a12.005 12.005 0 01-1.168-2H10.4a30.616 30.616 0 01-.379-4H4.05c-.027-.33-.05-.662-.05-1 0-.338.023-.67.05-1h5.971c.043-1.401.173-2.743.379-4H5.105c.326-.707.717-1.375 1.168-2h4.536c.443-1.787 1.052-3.322 1.776-4.498A11.957 11.957 0 0116 4c1.187 0 2.332.18 3.415.502.723 1.176 1.332 2.711 1.775 4.498h4.536c.451.625.842 1.293 1.168 2h-5.295c.206 1.257.336 2.599.379 4h5.971c.027.33.051.662.051 1 0 .338-.024.67-.051 1h-5.971a30.616 30.616 0 01-.379 4h5.295a12.005 12.005 0 01-1.168 2H21.19zM16 2C8.267 2 2 8.268 2 16s6.267 14 14 14c7.732 0 14-6.268 14-14S23.732 2 16 2z",
    fill: props.color
  }));
}

export default SvgIconWorldRexFilled;